<div class="flex flex-col gap-4">
  <h5 class="text-xl">{{ myTranslation("officeAddin.candidateList") }}</h5>

  <div class="flex flex-row gap-4">
    <div class="flex gap-2 items-center">
      <p-radioButton [(ngModel)]="tableMode" [value]="TableMode.Relational"></p-radioButton>
      <label>{{ myTranslation("officeAddin.relationalMode") }}</label>
    </div>

    <div class="flex gap-2 items-center">
      <p-radioButton [(ngModel)]="tableMode" [value]="TableMode.Flat"></p-radioButton>
      <label>{{ myTranslation("officeAddin.flatMode") }}</label>
    </div>
  </div>

  <p-floatLabel variant="in">
    <p-dropdown [showClear]="true" [options]="lists" [(ngModel)]="selectedList" optionLabel="name"></p-dropdown>
    <label>{{ myTranslation("officeAddin.allCandidates") }}</label>
  </p-floatLabel>

  <new-ui-button label="{{ myTranslation('officeAddin.importCandidateData') }}" (click)="getData()"></new-ui-button>
  @if (!prodMode) {
    <ng-template>
      <div (click)="clearWorkbook()" class="cursor-pointer text-xs">reset workbook (debug)</div>
    </ng-template>
  }
</div>
